function sleep (time) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

export default {
    methods: {
    toggle_lang: function(x, keywords_chosen) {
      console.log('toggle', x, keywords_chosen);

      $('.tag_custom').removeClass('btn-link');
      $('.tag_custom').removeClass('btn-success');
      $('.tag_custom').removeClass('btn-other');
      $('.tag_custom').removeClass('btn-danger');

      $('.lang_custom').removeClass('btn-link');
      $('.lang_custom').removeClass('btn-success');
      sleep(25).then(() => {
      	
      $('#lang_' + x).toggleClass('btn-success');
    for (var i = 0; i < keywords_chosen.length; i++) {  
      for (var j = 0; j < keywords_chosen.length;j++) { 
        console.log(keywords_chosen[i], keywords_chosen[j], i, j);
        if (((keywords_chosen[i].substring(0,keywords_chosen[i].length-2) == 
                  keywords_chosen[i].substring(0,keywords_chosen[j].length-2))))
        {
          if ((keywords_chosen[i].substring(keywords_chosen[i].length-2, keywords_chosen[i].length) == 
                 x.substring(x.length-2, x.length))) {
              // $('#tag_' + keywords_chosen[i].substring(0, keywords_chosen[i].length-2) + x.substring(
              //     x.length-2, x.length)).removeClass('btn-other');
            $('#tag_' + keywords_chosen[i].substring(0, keywords_chosen[i].length-2) + x.substring(
                  x.length-2, x.length)).addClass('btn-success');
            }
            else {
              $('#tag_' + keywords_chosen[i].substring(0, keywords_chosen[i].length-2) + x.substring(
                  x.length-2, x.length)).addClass('btn-other');
            }
          }
        }
      }


	      // for (var i = 0; i < keywords_chosen.length; i++) {	
       //    console.log(keywords_chosen[i].substring(0, keywords_chosen[i].length-2));
       //    $('[id^="tag_' + keywords_chosen[i].substring(0, keywords_chosen[i].length-2) + '"]').addClass('btn-info');
       //    $('#tag_' + keywords_chosen[i]).removeClass('btn-other');
       //    $('#tag_' + keywords_chosen[i]).removeClass('btn-danger');
       //    $('#tag_' + keywords_chosen[i]).addClass('btn-success');
	      // }


      });
    },
}
}


// WEBPACK FOOTER //
// ./src/mixins/toggle_lang.js